import { ImportType } from '@next-space/fe-api-idl';
import { publicLink } from 'src/common/const';
import { i18n } from '@flowus/common/i18n';
import type { ImportBtnType } from './types';

export const IMPORT_MODAL_ID = 'import-modal';
export const NOTION_MODAL_ID = 'notion-modal';

export const btnConfig: ImportBtnType = {
  [ImportType.MARKDOWN]: {
    // icon: 'MIcImportMarkdown',
    icon: 'IcMarkdown',
    title: 'Markdown',
    description: i18n.t('components.import.support_zip_rar'),
    accept: '.md,.zip,.rar',
  },
  [ImportType.CSV]: {
    icon: 'IcTable',
    title: 'CSV',
    description: '',
    accept: '.csv',
  },
  [ImportType.HTML]: {
    icon: 'IcEmbeddedWebpage',
    title: 'HTML',
    description: '',
    accept: '.html,.zip,.rar',
  },
  [ImportType.WORD]: {
    // icon: 'MIcImportWord',
    icon: 'MIcWord',
    title: 'Word',
    description: i18n.t('components.import.support_docx'),
    accept: '.docx,.zip,.rar',
  },
  [ImportType.NOTION]: {
    icon: 'MIcImportNotion',
    title: 'Notion',
    description: i18n.t('components.import.via_notion_api'),
    accept: '',
    help: publicLink.importFromNotion,
  },
};
